
import React, { useState, Fragment, useRef, useEffect } from "react"
import { toast } from "react-toastify"
import { FaCheckCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { changeOrderStatusToDelivered } from "services"
import { ConfirmationModal, IconButton } from "components"
import classes from "./OrderDetailCompleteButton.module.scss"

const OrderDetailCompleteButton = props => {
  const { order, setOrders } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleCompleteOrder = async () => {
    setSending(true)

    try {
      await changeOrderStatusToDelivered(order._id)

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ? { ...o, orderStatus: "delivered" }
            : o
        )
      )
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_تکمیل_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        className={classes["container"]}
        onClick={() => setShowConfirmationModal(true)}
      >
        <IconButton
          icon={FaCheckCircle}
          size={18}
          color="var(--color-success)"
          loadingColor="black"
        />
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {t("تکمیل_سفارش")}
        </span>
      </div>
      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_تکمیل_کنید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrder}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailCompleteButton